<template>

<div id="slide03" class="section section-light">

  <div class="slide03-chart">
    <Qimage :name="image"/>
  </div>

  <div class="slide03-bullets">

    <div class="one-third-block one-third-block-no-last">
      <Qimage name="slide03bullet01.png"/>

      <Small :text="$t('home.slide03.bullets.bullet01')"/>
    </div>

    <div class="one-third-block one-third-block-no-last one-third-block-no-first">
      <Qimage name="slide03bullet02.png"/>

      <Small :text="$t('home.slide03.bullets.bullet02')"/>
    </div>

    <div class="one-third-block one-third-block-no-first">
      <Qimage name="slide03bullet03.png"/>

      <Small :text="$t('home.slide03.bullets.bullet03')"/>
    </div>

  </div>

</div>

</template>

<script>
import Qimage from '../general/elements/Qimage.vue'
import Small from '../general/texts/Small.vue'

export default {
  name: 'Slide03',
  computed: {
    currentLang: function() {
      try {
        var locale = this.$parent.$locale
        if ((locale == undefined) || (locale == null)) {
          locale = 'en'
        }
        return locale
      }
      catch(e) {
        return 'en'
      }
    },
    image: function() {
      return 'graph-' + this.currentLang + '.png'
    }
  },
  components: {
    Qimage,
    Small
  }
}
</script>

<style lang="scss" scoped>
.section {
  width: 76%;
  padding: 100px 12%;
  margin: auto;

  .slide03-chart {
    img {
      width: 100%;
      display: block;
    }
  }

  .slide03-bullets {
    padding-top: 50px;

    .one-third-block {
      img {
        width: 100%;
      }

      div {
        text-align: center;
        font-family: 'Poppins-ExtraBold';
        font-weight: bold;
      }
    }
  }
}

@media (max-width: 900px), (max-device-width: 900px) {
  .section {
    .slide03-bullets {
      padding-top: 20px;

      .one-third-block {
        width: 50%;
      }

      .one-third-block-no-last {
        margin: 30px auto;
      }

      .one-third-block-no-first {
        margin: 30px auto;
      }
    }
  }
}

@media (max-width: 750px), (max-device-width: 750px) {
  .section {
    .slide03-bullets {
      .one-third-block {
        width: 60%;
      }
    }
  }
}

@media (max-width: 550px), (max-device-width: 550px) {
  .section {
    .slide03-bullets {
      .one-third-block {
        width: 80%;
      }
    }
  }
}

@media (max-width: 450px), (max-device-width: 450px) {
  .section {
    .slide03-bullets {
      .one-third-block {
        width: 90%;
      }
    }
  }
}

@media (max-width: 350px), (max-device-width: 350px) {
  .section {
    .slide03-bullets {
      .one-third-block {
        width: 100%;
      }
    }
  }
}
</style>
